import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { getConfig, getConfigFulfilled, updateConfig } from './config_thunk'

const initialState = {
  configuration: {},
  status: '',
  message: ''
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  extraReducers: {
    [getConfig.pending]: asyncIsPending,
    [getConfig.rejected]: asyncIsRejected,
    [getConfig.fulfilled]: getConfigFulfilled,
    [updateConfig.pending]: asyncIsPending,
    [updateConfig.rejected]: asyncIsRejected,
    [updateConfig.fulfilled]: asyncIsFulfilled,
  }
});

export default configSlice.reducer;